import StyledAction from './StyledAction'

interface SubmitActionProps {
  actionHandler(...args: unknown[]): unknown
  analytics?: object
  causesValidation?: boolean
  color?: string
  confirmation?: object
  data?: object
  disabled?: boolean
  format?: 'normal' | 'outline'
  orientation?: string
  title: string
  type: 'Action.Submit'
}

const SubmitAction = ({
  actionHandler,
  type,
  title,
  data,
  analytics,
  causesValidation,
  orientation,
  color,
  format,
  disabled,
  confirmation
}: SubmitActionProps) => {
  const handleAction = (e: any) => {
    e.stopPropagation()

    actionHandler(type, title, {
      data,
      analytics,
      causesValidation,
      confirmation: confirmation || null
    })
  }

  return (
    // @ts-expect-error
    <StyledAction orientation={orientation} color={color} format={format} onClick={handleAction} disabled={disabled}>
      {title}
    </StyledAction>
  )
}

SubmitAction.displayName = 'ACSubmitAction'

SubmitAction.defaultProps = {
  title: '',
  data: {},
  analytics: {},
  color: 'link',
  causesValidation: true,
  format: 'normal',
  type: 'Action.Submit'
}

export default SubmitAction
